import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./NavLogs.scss";
import { navLogShape, resolutionPropType } from "app/utils/propTypes";
import { FormattedMessage } from "react-intl";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import NavLogProduct from "app/pages/Listing/NavLogs/NavLogProduct";
import Separator from "app/pages/.shared/Separator";
import { sendTagOnNavlogNext, sendTagOnNavlogPrevious } from "app/utils/analytics";
import { NAVLOGS_SHOW_SLIDES_NUMBER } from "app/constants";
import Swiper from "react-id-swiper";

const PLACEHOLDER_ID = "navlog-placeholder";

const NavLogs = ({ navLogs = [], resolution }) => {
	const [swiper, setSwiper] = useState(null);
	const [isBeginning, setIsBeginning] = useState(true);
	const [isEnd, setIsEnd] = useState(false);

	const updateSwiper = swiper => {
		setSwiper(swiper);
	};

	const slidePrev = () => {
		swiper.slidePrev();
	};

	const slideNext = () => {
		swiper.slideNext();
	};

	const slidePrevTransitionEnd = () => {
		sendTagOnNavlogPrevious();
	};

	const isDesktop =
		resolution === RESOLUTION.LARGE ||
		resolution === RESOLUTION.XLARGE ||
		resolution === RESOLUTION.MEDIUM;

	const showArrows = isDesktop && navLogs.length > 3;

	const swiperParams = {
		shouldSwiperUpdate: true,
		getSwiper: updateSwiper,
		slidesPerView: NAVLOGS_SHOW_SLIDES_NUMBER[resolution],
		spaceBetween: 10,
		centeredSlides: !isDesktop && navLogs.length === 1,
		on: {
			slidePrevTransitionEnd: slidePrevTransitionEnd,
		},
	};

	// si on affiche moins de 3 produits, alors on complete avec des placeholders jusqu'à 3
	if (isDesktop) {
		if (navLogs.length === 1) {
			navLogs.push({
				uri: PLACEHOLDER_ID,
				id: `${PLACEHOLDER_ID}-1`,
				url: "/static/picture/beach-placeholder.svg",
			});
			navLogs.push({
				uri: PLACEHOLDER_ID,
				id: `${PLACEHOLDER_ID}-2`,
				url: "/static/picture/city-placeholder.svg",
			});
		} else if (navLogs.length === 2) {
			navLogs.push({
				uri: PLACEHOLDER_ID,
				id: `${PLACEHOLDER_ID}-1`,
				url: "/static/picture/beach-placeholder.svg",
			});
		}
	}

	useEffect(() => {
		if (swiper) {
			swiper.on("slideChangeTransitionEnd", () => {
				const isBeginning = swiper?.isBeginning;
				const isEnd = swiper?.isEnd;

				setIsBeginning(isBeginning);

				setIsEnd(isEnd);
			});

			swiper.on("slideNextTransitionEnd", () => {
				const navigateToSlideIndex = Math.round(
					NAVLOGS_SHOW_SLIDES_NUMBER[resolution] + swiper.activeIndex - 1
				);

				sendTagOnNavlogNext({
					...navLogs[navigateToSlideIndex],
					lastSeenProductType: navLogs[navigateToSlideIndex]?.quotationURL
						? "quote"
						: "product",
				});
			});
		}
	}, [swiper]);

	return (
		navLogs.length >= 1 && (
			<div className="navlogs">
				<h4 className="navlogs__title">
					<FormattedMessage id="listing.last.viewed.trip" />
				</h4>

				<div className="navlogs__carousel">
					<Swiper {...swiperParams}>
						{navLogs.map(navLog => {
							if (navLog.uri === PLACEHOLDER_ID) {
								return (
									<div key={navLog.id} className="navlogs__placeholder">
										<div
											style={{
												backgroundImage: `url("${navLog.url}")`,
											}}
											className="navlogs__placeholder-picture"
										/>
										<div className="navlogs__placeholder-text">
											<FormattedMessage id="general.upcoming.trip.label" />
										</div>
									</div>
								);
							}

							return (
								<div key={navLog.id}>
									<NavLogProduct {...navLog} resolution={resolution} />
								</div>
							);
						})}
					</Swiper>
					<div className="navlogs__carousel__button navlogs__carousel__button--next">
						{showArrows && !isEnd && swiper && (
							<i className="icon icon-navigation icon--next" onClick={slideNext} />
						)}
					</div>
					<div className="navlogs__carousel__button navlogs__carousel__button--previous">
						{showArrows && !isBeginning && swiper && (
							<i
								className="icon icon-navigation icon--previous"
								onClick={slidePrev}
							/>
						)}
					</div>
				</div>
				<Separator design="middle" />
			</div>
		)
	);
};

NavLogs.propTypes = {
	navLogs: PropTypes.arrayOf(navLogShape),
	resolution: resolutionPropType,
};

export default NavLogs;
